import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHelper } from 'src/cad/common/services/api/api-helper';
import { CRBidData } from 'src/cad/capacity-release/shared/interfaces/cr-bid-data';
import {IProcessResultModel} from 'common/services/process-status/process-status.service';

@Injectable()
export class CapacityReleaseOfferBidsMatchBidApi {
  private readonly endpoint: string = 'capacity-release/offer/';
  private readonly suffix: string = '/bids';
  private readonly suffix2: string = '/match-bid';
  private readonly multiSuffix: string = '/multi';

  constructor(private apiHelper: ApiHelper) {}

  public getMatchBids(auctionId: number | string, bidId: number | string): Observable<any> {
    return this.apiHelper.request(this.endpoint + auctionId + this.suffix + '/' + bidId + this.suffix2);
  }

  public matchBid(auctionId: number | string, bidId: number | string, matchBidData: CRBidData): Observable<any> {
    return this.apiHelper.request(
      this.endpoint + auctionId + this.suffix + '/' + bidId + this.suffix2,
      { body: matchBidData, quiet: true }
    );
  }

  public multiMatchBid(auctionId: number | string,  bidId: number | string, matchBidDataList: CRBidData[]): Observable<IProcessResultModel> {
    return this.apiHelper.request(
      this.endpoint + auctionId + this.suffix + '/' + bidId + this.suffix2 + this.multiSuffix,
      { body: matchBidDataList, quiet: true }
    );
  }
}
